import PlanDetailsCard from './index'
import { useState } from 'react'
import classnames from 'classnames/bind'
import css from './styles.module.scss'
import Button from '../Button'
const cx = classnames.bind(css)

const getActiveCardKey = (cards) => {
  return cards.plan.data.id
}

const GroupedPlanDetailsCard = ({ cards, previousPlanName }) => {
  const [activeCardKey, setActiveCardKey] = useState(() =>
    cards.length > 1
      ? getActiveCardKey(cards.find((card) => card.tabDefault) ?? cards[0])
      : null
  )

  if (cards.length === 1) {
    return <PlanDetailsCard {...cards[0]} previousPlanName={previousPlanName} />
  }

  const activeCard = cards.find(
    (card) => getActiveCardKey(card) === activeCardKey
  )

  return (
    <PlanDetailsCard
      previousPlanName={previousPlanName}
      subtextComponent={
        <CardToggle
          cards={cards}
          activeCardKey={activeCardKey}
          setActiveCardKey={setActiveCardKey}
        />
      }
      {...activeCard}
    />
  )
}

const CardToggle = ({ cards, activeCardKey, setActiveCardKey }) => {
  return (
    <div className={css.billingToggle}>
      {cards.map((card) => (
        <Button
          tagName="button"
          buttonClassName={css.billingOption}
          fullWidth
          theme={getActiveCardKey(card) === activeCardKey ? "white": "transparent-blue-500"}
          onClick={() => setActiveCardKey(getActiveCardKey(card))}
          withoutShadow={getActiveCardKey(card) !== activeCardKey}
        >
          {card.plan?.data?.attributes?.subtext}
        </Button>
      ))}
    </div>
  )
}

export default GroupedPlanDetailsCard
